import { render } from "./PCLecturaEnvasesPale.vue?vue&type=template&id=0f7b6e40&scoped=true"
import script from "./PCLecturaEnvasesPale.vue?vue&type=script&lang=js"
export * from "./PCLecturaEnvasesPale.vue?vue&type=script&lang=js"

import "./PCLecturaEnvasesPale.vue?vue&type=style&index=0&id=0f7b6e40&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7b6e40"]])

export default __exports__